import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App.tsx';
import './index.css';
import { captureAttributionFromUrl } from './lib/attribution';

// SDA-267: capture campaign attribution params synchronously, BEFORE React
// renders — EventSearchPage rewrites the query string on its first re-search,
// so an App-level effect would race it and lose the params.
captureAttributionFromUrl(window.location.search);

const root = document.getElementById('root');
if (!root) throw new Error('Root element not found');

createRoot(root).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>
);
